export const VAS = {
  POLISHING: {
    id_servizio: 11,
    id_vas: 'c6ce6751-3e1c-4caf-93fb-70fb87ace7eb',
  },
  SECURITY_KIT: {
    id_servizio: 15,
    id_vas: '55f55818-9ab4-4666-aa44-fca05be50e60',
  },
  ONE_YEAR_GUARANTEE: {
    id_servizio: 12,
    id_vas: '362543c7-2d47-4768-affb-a389830ca50a',
  },
}
